export const SET_DASHBOARD = 'SET_DASHBOARD'
export const SET_DASHBOARD_BREAKOUT = 'SET_DASHBOARD_BREAKOUT'
export const SET_DASHBOARD_TOP3 = 'SET_DASHBOARD_TOP3'
export const SET_DASHBOARD_TOP = 'SET_DASHBOARD_TOP'
export const SET_DASHBOARD_PROFIT = 'SET_DASHBOARD_PROFIT'
export const SET_DASHBOARD_CYCLETIMES = 'SET_DASHBOARD_CYCLETIMES'
export const SET_DASHBOARD_TREND = 'SET_DASHBOARD_TREND'
export const SET_DATE = 'SET_DATE'
export const SET_VIEW = 'SET_VIEW'
export const SET_INVOICES = 'SET_INVOICES'
export const SET_PAYROLL = 'SET_PAYROLL'
export const SET_OPPORTUNITIES = 'SET_OPPORTUNITIES'
export const SET_TECHDATA = 'SET_TECHDATA'
export const SET_DATA = 'SET_DATA'
export const SET_PAYMENTS = 'SET_PAYMENTS'
export const SET_PARAMETER = 'SET_PARAMETER'
export const SET_LOG = 'SET_LOG'
export const RESET_LOG = 'RESET_LOG'
export const FILTER_LOG = 'FILTER_LOG'
export const SET_HISTORY = 'SET_HISTORY'
export const SET_TIMEZONE = 'SET_TIMEZONE'
export const SET_FRAGMENTATION = 'SET_FRAGMENTATION'
export const SET_MISSING_INDEXES = 'SET_MISSING_INDEXES'



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/types.js